import { Component, OnInit, ViewChild } from '@angular/core';
import { Data } from '../../comum/data/data';
import { ResultadoColeta } from '../../comum/modelos/resultado-coleta';
import { ColetaService } from '../coleta.service';
import { FiltroResultadoColeta } from '../../comum/modelos/filtro-resultado-coleta';
import { ResultadoCriterioColeta } from '../../comum/modelos/resultado-criterio-coleta';
import { ModalListaColetasGraficoComponent } from '../modal-lista-coletas-grafico/modal-lista-coletas-grafico.component';

@Component({
    selector: 'app-resultado-coleta',
    templateUrl: './resultado-coleta.component.html',
    styleUrls: ['./resultado-coleta.component.css']
})
export class ResultadoColetaComponent implements OnInit {
    @ViewChild('modalListaColetasGrafico') modal: ModalListaColetasGraficoComponent;

    resultadosColeta: ResultadoColeta[];
    filtroResultadoColeta: FiltroResultadoColeta;

    public loading = false;

    view: any[] = [600, 300];

    showLabels = true;
    showLegend = true;
    tooltipDisabled = false;
    title: 'Resultado de Coletas';
    colorScheme = {
        domain: ['#a8385d', '#7aa3e5', '#a27ea8', '#aae3f5', '#adcded', '#a95963', '#8796c0', '#7ed3ed', '#50abcc', '#ad6886']
    };

    // line, area
    autoScale = true;

    constructor(
        private _coletaService: ColetaService,
        private data: Data) {
        this.resultadosColeta = new Array<ResultadoColeta>();
        this.filtroResultadoColeta = new FiltroResultadoColeta();
    }

    ngOnInit() {
        this.loading = true;
        const self = this;
        this.filtroResultadoColeta = this.data.storage.filtroResultadoColeta;

        this._coletaService.obterResultadosColetaHttp(this.filtroResultadoColeta)
            .subscribe((response) => {
                self.resultadosColeta = response.body;
                self.resultadosColeta.forEach(resultadoColeta => {
                    resultadoColeta.filtroIdUsuario = this.filtroResultadoColeta.idUsuario;
                    resultadoColeta.chartData = new Array<any>();
                    resultadoColeta.dataInicioReferencia = this.filtroResultadoColeta.dataInicioReferencia;
                    resultadoColeta.dataFimReferencia = this.filtroResultadoColeta.dataFimReferencia;
                    resultadoColeta.resultadosCriterioColeta.map(function (resultadoCriterioColeta) {
                        resultadoColeta.chartData.push({
                            name: resultadoCriterioColeta.nomeCriterioAvaliacao,
                            value: resultadoCriterioColeta.numeroOcorrencias
                        });
                    });

                    resultadoColeta.chartData = [...resultadoColeta.chartData];
                    let totalOcorrencias = 0;
                    resultadoColeta.resultadosCriterioColeta.forEach(resultadoCriterio => {
                        totalOcorrencias += resultadoCriterio.numeroOcorrencias;
                    });
                    resultadoColeta.resultadosCriterioColeta.forEach(resultadoCriterio => {
                        resultadoCriterio.percentual = (resultadoCriterio.numeroOcorrencias / totalOcorrencias) * 100;
                    });
                });
                self.loading = false;
            });
    }

    onSelect(event: any, resultadoColeta: ResultadoColeta) {
        let criterio = new ResultadoCriterioColeta();
        for (const cri of resultadoColeta.resultadosCriterioColeta) {
            if (cri.nomeCriterioAvaliacao === event.name) {
                criterio = cri;
                break;
            }
        }
        this.modal.open(resultadoColeta, criterio);
        this.tooltipDisabled = true;
    }

    onActivate(data): void {
        this.tooltipDisabled = false;
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/resultado-coleta/resultado-coleta.component.ts